import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { AdvancedGridComponent } from '@app/features/v3ndor/components/advanced-grid/advanced-grid.component';
import { EntityPickerComponent } from '@app/features/v3ndor/components/entity-picker/entity-picker.component';
import { FilterWidgetModule } from '@app/shared/components/filter-widget/filter-widget.module';
import { FormModule } from '@app/shared/components/form/form.module';
import { PaginatorModule } from '@app/shared/components/paginator/paginator.module';
import { SearchModalModule } from '@app/shared/components/search-modal/search-modal.module';
import { SearchWidgetModule } from '@app/shared/components/search-widget/search-widget.module';
import { SortWidgetModule } from '@app/shared/components/sort-widget/sort-widget.module';
import { ResponsiveTableModule } from '@app/shared/components/table/responsive-table.module';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  AlertComponent,
  AvatarComponent,
  BadgeComponent,
  ButtonComponent,
  CalloutComponent,
  CardComponent,
  ConfirmDialogComponent,
  DividerComponent,
  IconComponent,
  ListGroupDirective,
  ListGroupItemDirective,
  ModalComponent,
  OverlayComponent,
  SpinnerComponent,
  TabviewComponent,
  TimelineComponent,
  ToastModule,
  ToolbarComponent,
  TooltipDirective,
} from '@teorema/patron';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { HighlightModule } from 'src/app/shared/pipes/highlight.pipe';
import { AuthComponent } from './auth.component';
import { AuthGuard } from './auth.guard';
import { AuthInterceptor } from './auth.interceptor';
import { GridWriteTrackingInterceptor } from '@app/features/v3ndor/components/advanced-grid/grid-write-tracking.interceptor';
import { AuthRoutingModule } from './auth.routing';
import { BwUserBulkMaintenanceComponent } from './bw-users/bw-user-bulk-maintenance/bw-user-bulk-maintenance.component';
import { BwUserListComponent } from './bw-users/bw-user-list/bw-user-list.component';
import { BwUserViewComponent } from './bw-users/bw-user-view/bw-user-view.component';
import { BwUsersPendingListComponent } from './bw-users/bw-users-pending-list/bw-users-pending-list.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { AuthLayoutComponent } from './layout/layout.component';
import { PageForbiddenComponent } from './page-forbidden/page-forbidden';
import { PageNotFoundComponent } from './page-not-found/page-not-found';
import { MySessionsComponent } from './profile/my-sessions/my-sessions.component';
import { ProfileComponent } from './profile/profile.component';
import { PipelineAccessComponent } from '../features/ai/components/pipeline-access/pipeline-access.component';
import { FilterModulesPipe } from './profiles/profile-form/filter-modules.pipe';
import { ProfileFormComponent } from './profiles/profile-form/profile-form.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { RegisterCompanyComponent } from './register-company/register-company.component';
import { NewPasswordComponent } from './reset-password/new-password/new-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SelectCompanyComponent } from './select-company/select-company.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { UserSellerGuard } from './user-seller.guard';
import { VersionHistoryComponent } from './version-history/version-history.component';
import { LicensesSharedModule } from '../modules/manager/company-group-licenses/licenses-shared.module';

@NgModule({
  declarations: [
    AuthLayoutComponent,
    AuthComponent,
    ChangePasswordComponent,
    ProfileComponent,
    MySessionsComponent,
    VersionHistoryComponent,
    BwUserListComponent,
    BwUserBulkMaintenanceComponent,
    BwUserViewComponent,
    BwUsersPendingListComponent,
    PageNotFoundComponent,
    PageForbiddenComponent,
    ServerErrorComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
    ProfilesComponent,
    ProfileFormComponent,
    FilterModulesPipe,
    SelectCompanyComponent,
    RegisterCompanyComponent,
    ConfirmEmailComponent,
  ],
  exports: [AuthComponent, ChangePasswordComponent, SelectCompanyComponent],
  imports: [
    CommonModule,
    PipelineAccessComponent,
    AuthRoutingModule,
    LicensesSharedModule,
    CardComponent,
    ButtonComponent,
    FormsModule,
    IconComponent,
    FormModule,
    AlertComponent,
    OverlayComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    NgSelectModule,
    ToolbarComponent,
    BadgeComponent,
    AvatarComponent,
    TabviewComponent,
    ConfirmDialogComponent,
    ResponsiveTableModule,
    PaginatorModule,
    SearchWidgetModule,
    FilterWidgetModule,
    SortWidgetModule,
    SearchModalModule,
    CalloutComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    DividerComponent,
    TimelineComponent,
    ToastModule,
    CurrencyMaskModule,
    HighlightModule,
    ModalComponent,
    ConfirmDialogComponent,
    NgSelectModule,
    OverlayComponent,
    SpinnerComponent,
    HighlightModule,
    EntityPickerComponent,
    AdvancedGridComponent,
    TooltipDirective,
  ],
  providers: [
    provideAuth(() => getAuth()),
    AuthGuard,
    UserSellerGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GridWriteTrackingInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AuthModule {}
